<template>
<div class="form" style="margin-top: 100px">
  <v-card class="grey lighten-5">
      <v-container>
      <h1 align="center">Daftar Kod Item 4a</h1><br>

      <v-form ref="formsimpansampel" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="2">
               <v-text-field
                  outlined
                  dense
                  v-model="koditem"
                  label="Kod Item"
                  type="number"
                  :rules="required8digit"
                  @keypress="limitDigits8"
                ></v-text-field>
            </v-col>

             <v-col cols="2">
               <v-select
               v-model="jenisbarang"
              :items="[0,1,2,3,4,5]"
              label="Jenis Barang"
              :rules="requiredRules"
              outlined
              dense
              ></v-select>
            </v-col>
           
            <v-col cols="1">
               <v-text-field
                  outlined
                  dense
                  v-model="unit"
                  label="Unit"
                  type="number"
                  :rules="required2digit"
                  @keypress="limitDigits"
                ></v-text-field>
            </v-col>

            <v-col cols="3">
               <v-text-field
                  outlined
                  dense
                  v-model="nama"
                  label="Nama Unit"
                  type="text"
                  :maxlength="20"
                  :rules="requiredRule"
                ></v-text-field>
            </v-col>

            <v-col cols="2">
               <v-select
                  outlined
                  dense
                  v-model="index"
                  :items="[ { text: 'Tidak', value: 0 }, { text: 'Ya', value: 1 }]"
                  label="Index"
                  :rules="requiredRuled"
                ></v-select>
            </v-col>

            <v-col cols="10">
               <v-text-field
                  outlined
                  dense
                  v-model="keterangan"
                  label="Keterangan"
                  :maxlength="500"
                  :rules="requiredRule"
                ></v-text-field>
            </v-col>
  
             <v-col>
              <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="simpansampel"
              >
                {{ $t("tambah") }}
              </v-btn>
            </v-col>
          </v-row>
           </v-form>
           <!-- Table Data -->
        <v-card>
            <v-card-title>
              {{ $t("senaraikoditem") }}
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="dataKod"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
            ></v-data-table>
          </v-card>

          <!-- Row Click Dialog -->
      <v-dialog v-model="rowClick" max-width="500" persistent>
        <v-form ref="formUpdate" v-model="dialogValid" lazy-validation>
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("senaraikoditem") }}
        </v-card-title>
        <v-card-text>
          <v-row>
          <v-col>
              <div class="text-subtitle-2 font-weight-medium mb-1">Kod Item</div>
              <v-text-field
                outlined
                dense
                v-model="paparkoditem.koditem"
                :rules="required8digit"
                @keypress="limitDigits8"
              ></v-text-field>
            </v-col>

            <v-col>
              <div class="text-subtitle-2 font-weight-medium mb-1">Jenis Barang</div>
              <v-select
               v-model="paparkoditem.jenisbarang"
              :items="[0,1,2,3,4,5]"
              label="Jenis Barang"
              :rules="requiredRules"
              outlined
              dense
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
          <v-col>
              <div class="text-subtitle-2 font-weight-medium mb-1">Unit</div>
              <v-text-field
                outlined
                dense
                v-model="paparkoditem.unit"
               :rules="required2digit"
               @keypress="limitDigits" 
              ></v-text-field>
            </v-col>

            <v-col>
              <div class="text-subtitle-2 font-weight-medium mb-1">Nama Unit</div>
              <v-text-field
                outlined
                dense
                v-model="paparkoditem.nama"
               :rules="requiredRule"
               :maxlength="20"
              ></v-text-field>
            </v-col>
          </v-row>

           <v-row>
          <v-col>
              <div class="text-subtitle-2 font-weight-medium mb-1">Index</div>
               <v-select
                  outlined
                  dense
                  v-model="paparkoditem.index"
                  :items="[ { text: 'Tidak', value: 0 }, { text: 'Ya', value: 1 }]"
                  label="Index"
                  :rules="requiredRuled"
                ></v-select>
            </v-col>

            <v-col>
              <div class="text-subtitle-2 font-weight-medium mb-1">Keterangan</div>
              <v-text-field
                outlined
                dense
                v-model="paparkoditem.keterangan"
                :rules="requiredRule"
                :maxlength="500"
              ></v-text-field>
            </v-col>
          </v-row>

          </v-card-text>

          <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="warning" @click="rowClick = false"> {{ $t("batal")}} </v-btn>

          <v-btn color="primary" @click="Pengesahankemaskini = true" > {{ $t("kemaskini")}} </v-btn>

          <v-btn color="error" @click="Pengesahanpadam = true" >{{ $t("padam")}} </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    </v-dialog>

            <!-- Pengesahan Kemaskini Dialog -->

 <v-row justify="center">
    <v-dialog
      v-model="Pengesahankemaskini"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dikemaskini!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk mengemaskini pengisian?")}}<br><br>
         <strong>{{$t(" Kod Item: "+ originalKoditem)}}</strong> 
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="Pengesahankemaskini= false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="updatesampel(paparkoditem)"
          >
            {{$t('kemaskini')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row> 

   <!-- Pengesahan Padam Dialog -->

 <v-row justify="center">
    <v-dialog
      v-model="Pengesahanpadam"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <strong>{{$t(" Kod Item: "+this.paparkoditem.koditem)}}</strong> 
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="Pengesahanpadam= false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padam(paparkoditem.koditem)"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row> 



        <!-- Success Dialog -->
        <v-dialog v-model="successDialog" max-width="400">
          <v-card>
            <v-card-title class="headline">Berjaya!!</v-card-title>
            <v-card-text>{{ successMessage }}</v-card-text>
            <v-card-actions>
              <v-btn color="green" text @click="closeDialogs">Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Error Dialog -->
        <v-dialog v-model="errorDialog" max-width="400">
          <v-card>
            <v-card-title class="headline">Gagal!!</v-card-title>
            <v-card-text>{{ errMessage }}</v-card-text>
            <v-card-actions>
              <v-btn color="red" text @click="closeDialogs">Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import axios from "../../plugins/axios";

export default {
  data() {
    return {
      successDialog: false,
      errorDialog: false,
      successMessage: 'Data Disimpan!',
      errMessage: 'Sila semak pengisian!',
      valid: false,
      dialogValid: false,
      search: "",
      dataKod:[],
      koditem:"",
      jenisbarang:"",
      unit:"",
      nama:"",
      index:"",
      keterangan:"",
      paparkoditem:[],
      rowClick: false,
      Pengesahankemaskini: false,
      Pengesahanpadam: false,

      requiredRule: [
      v => !!v || 'Perlu di isi',
      ],
      
      requiredRuled: [
       v => v === 0 || v === 1 || 'Sila pilih Ya atau Tidak',
      ],

      requiredRules: [
       v => [0,1,2,3,4,5].includes(v) || 'Silih pilih dan isi',
      ],

      required8digit: [
      v => !!v || 'Perlu di isi',
      v => /^\d{8}$/.test(v) || 'Mesti 8 digit nombor'
      ],
      
      required2digit: [
      v => !!v || 'Perlu di isi',
      v => /^\d{1}$/.test(v) || 'Mesti 1 digit nombor'
      ],

      headers: [
        { text: "Bil.", value: "no", sortable: false },
        { text: 'Kod Item', value: "koditem" },
        { text: 'Jenis Barang', value: "jenisbarang" },
        { text: 'Unit', value: "unit" },
        { text: 'Nama Unit', value: "nama" },
        { text: 'Index ( Item dibahagi 12 )', value: "index" }, 
        { text: 'Keterangan', value: "keterangan" },
      ],
       };
  },
 mounted() {
    this.kodItem();
  },
  methods: {
    
    limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 1) {
            event.preventDefault();
        }
      },

    limitDigits8(event) {
        const value = event.target.value;
        if (value.length >= 8) {
            event.preventDefault();
        }
      },

async simpansampel() {
  if (this.$refs.formsimpansampel.validate()) {
      try {

    // Check if KodItem already exists
       const checkResponse = await axios.get(`${process.env.VUE_APP_API_URL}/Koditem/checkKodItem4a`, {
        params: { koditem: this.koditem}
      });

      if (checkResponse.data.exists) {
        this.errMessage = "Kod Item ini sudah wujud!";
        this.errorDialog = true;
        return; 
      }

    axios.post(`${process.env.VUE_APP_API_URL}/Koditem/insertKod4a`, {
      koditem: this.koditem,
      jenisbarang: this.jenisbarang,
      unit: this.unit,
      nama: this.nama,
      index: this.index,
      keterangan: this.keterangan,
     });

      this.successDialog = true;
      this.errorDialog = false;
      this.reset();
      await this.kodItem(); // tunggu fetch siap baru proceed
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.successDialog = false;
         window.location.reload();
      }, 2000);

    } catch (error) {
      console.error("Error saving data:", error.response ? error.response.data : error.message);
      this.errMessage = "Error: " + (error.response ? error.response.data.message : error.message);
      this.errorDialog = true;
    }
  } else {
    console.log("Form validation failed.");
    this.errorDialog = true;
    this.successDialog = false;
    window.scrollTo(0, 0);
  }
},

async kodItem() {

  try {
    const res = await axios.get(`${process.env.VUE_APP_API_URL}/Koditem/sampelKod4a`);
    console.log("Sampel response:", res.data);

    if (res && res.data && Array.isArray(res.data.data)) {
      const sampel = res.data.data.map((element, index) => ({
        no: index + 1,
        koditem: element.KodItem ,
        jenisbarang: element.JenisBarang ,
        unit: element.Unit ,
        nama: element.namaUnit ,
        index: element.Ind ,
        keterangan: element.Keterangan ,
      }));

      this.dataKod = sampel;
   } else {
      console.error("Unexpected response structure:", res);
      this.errMessage = "Unexpected response structure";
      this.errorDialog = true;
    }
  } catch (error) {
    console.error("Error fetching sampel:", error);
    this.errMessage = "Error: " + (error.response ? error.response.data.message : error.message);
    this.errorDialog = true;
  }
},

async handleClick(row) {
      this.rowClick = true;
      this.paparkoditem = { ...row,jenisbarang: Number(row.jenisbarang),
                         index: Number(row.index)};
                          // Pastikan ini number supaya match dengan v-select
      this.originalKoditem = row.koditem; // save original koditem separately                    
      this.Pengesahankemaskini = false;
      this.Pengesahanpadam = false;
    },

    async updatesampel() {
    if (this.$refs.formUpdate.validate()) {
      try {

      const originalKoditem = this.originalKoditem;  
      const newKoditem = this.paparkoditem.koditem;

       if (newKoditem === originalKoditem) {
      // Proceed to update with the original HID
      await axios.post(`${process.env.VUE_APP_API_URL}/Koditem/updateKod4a`, {
      koditem: newKoditem,
      oldKoditem: originalKoditem,
      jenisbarang: this.paparkoditem.jenisbarang,
      unit: this.paparkoditem.unit,
      nama: this.paparkoditem.nama,
      index: this.paparkoditem.index,
      keterangan: this.paparkoditem.keterangan,
      });
    } else {

     // Check if the new already exists
     const checkResponse = await axios.get(`${process.env.VUE_APP_API_URL}/Koditem/checkKodItem4a`, {
        params: { koditem: newKoditem,}
      });

      if (checkResponse.data.exists) {
        this.errMessage = "Kod Item sudah wujud dengan data yang sama!";
        this.errorDialog = true;
        return; 
      }

      await axios.post(`${process.env.VUE_APP_API_URL}/Koditem/updateKod4a`, {
      koditem: newKoditem,
      oldKoditem: originalKoditem,
      jenisbarang: this.paparkoditem.jenisbarang,
      unit: this.paparkoditem.unit,
      nama: this.paparkoditem.nama,
      index: this.paparkoditem.index,
      keterangan: this.paparkoditem.keterangan,
      });
    }


    // If the update is successful, now update the local data with the new HID
    const index = this.dataKod.findIndex(item => item.koditem === originalKoditem);
    if (index !== -1) {
      this.dataKod.splice(index, 1, { ...this.paparkoditem, koditem: newKoditem }); // Update with new data
    }

    this.successMessage = 'Data DiKemaskini!';
    this.successDialog = true; 
    this.rowClick = false;
    this.Pengesahankemaskini = false;

    setTimeout(() => {
      this.successDialog = false;
    }, 2000);
    window.scrollTo(0, 0);
    
  } catch (error) {
    console.error("Error updating data:", error.response ? error.response.data : error.message);
    this.errMessage = 'Kemaskini : ' + (error.response ? error.response.data.message : error.message);
    this.errorDialog = true;
  }
 
} },

async padam(koditem) {
  try {
    const res = await axios.post(`${process.env.VUE_APP_API_URL}/Koditem/deleteKod4a`, {
      koditem: koditem  
    });

    this.successMessage = 'Data Dipadam!';
    this.successDialog = true;
    this.dataKod = this.dataKod.filter(item => item.koditem !== koditem);
    this.rowClick = false; 
    this.Pengesahanpadam = false;
    setTimeout(() => {
      this.successDialog = false;
    }, 2000);

    window.scrollTo(0, 0);
  } catch (error) {
    this.errorDialog = true;
    setTimeout(() => {
      this.errorDialog = false;
    }, 2000);
    this.errMessage = 'Padam : ' + error;
  }  
},

  closeDialogs() {
    if (this.successDialog) {
      this.successDialog = false; 
    } else {
      this.errorDialog = false; 
    }
  },

  reset() {
    this.$refs.formsimpansampel.reset(); 
  },

  },
};
</script>
<style scoped>
</style>